module.exports = __webpack_public_path__ + "vue_assets/img/img_preorder_standalone.d72b7f0f.png";